import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { appRoutingModule } from "../app.routing";
import { FormsModule } from "@angular/forms";
import { ModalModule } from "ngx-bootstrap/modal";
import { PipesModule } from "../pipes";
import { DirectivesModule } from "../directives";
import { DpDatePickerModule } from 'ng2-date-picker';
import { PopulatedReportsComponent } from "./populatedReports";
import { PopulatedReportDetailsComponent } from "./populatedReportDetails";
import { PopulatedReportBudgetsComponent } from "./populatedReportBudgets";
import { WeeklyCsvExportDialogComponent } from "./weeklyCsvExportDialog";

@NgModule({
  	declarations: [
		PopulatedReportsComponent,
		PopulatedReportDetailsComponent,
		PopulatedReportBudgetsComponent,
		WeeklyCsvExportDialogComponent
	],
  	imports: [
		BrowserModule,
		appRoutingModule,
		FormsModule,
		DirectivesModule,
		ModalModule.forRoot(),
		PipesModule,
		DpDatePickerModule
	],
  	providers: [
	]
})
export class PopulatedReportsModule {}
